<template>
  <div class="createOrder-page full-height">
    <table-con>
      <!-- 搜索框 -->
      <div slot="search" v-if="dataList && dataList.length < 5">
        <el-row class="search-row">
          <el-col :span="24" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">
<!--              <el-button class="search-btn btn-blue" @click="searchList">{{$t('laund.laund6')}}</el-button>-->
              <el-button v-if="dataList && dataList.length < 5" class="search-btn btn-green" @click="doEdit({})">{{$t('add')}}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 表格 -->
      <div slot="table" class="full-height display-col" style="padding:10px">
        <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="dataList" border>
          <el-table-column label="序号" type="index" align="center" width="50">
            <template slot-scope="scope">
              <span>{{(queryInfo.pageNum - 1) * queryInfo.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('cnumber.cnumber11')" align="center" prop="userName">
          </el-table-column>
          <el-table-column :label="$t('cnumber.cnumber12')" align="center" prop="roleName">
          </el-table-column>
          <el-table-column :label="$t('addr.addr4')" align="center" prop="realName"></el-table-column>
          <el-table-column :label="'Email'" align="center" prop="emailAddress"></el-table-column>
          <el-table-column :label="$t('mail.status')" align="center" prop="userStatus">
            <template v-slot="scope">
              {{statusObj[scope.row.userStatus]}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('model.createTime')" align="center" prop="createDate">
            <template v-slot="scope">
              {{ scope.row.createDate | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('cnumber.cnumber13')" align="center" prop="lastActiveTime">
            <template v-slot="scope">
              {{ scope.row.lastActiveTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operate')" align="center">
            <template v-slot="scope">
<!--              <el-button class="list-btn btn-green" @click="doCopy(scope.row)">{{$t('cnumber.cnumber6')}}</el-button>-->
<!--              <el-button class="list-btn btn-green" @click="doCopy(scope.row)">{{$t('cnumber.cnumber7')}}</el-button>-->
              <el-button class="list-btn btn-deepblue" @click="doEdit(scope.row)">{{$t('laund.laund9')}}</el-button>
              <el-button class="list-btn btn-red" @click="drop(scope.row)">{{$t('laund.laund10')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
<!--        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum" :page-sizes="[5, 10, 20, 50, 100, 200]" :pager-count="5" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>-->
      </div>
    </table-con>
  </div>
</template>
<script>
import tableCon from "@/views/tableContainer";
export default {
  name: "numberList",
  components: {
    tableCon,
  },
  data() {
    return {
      dataList: [],
      queryInfo: {
        // bs: "",
        // name: "",
        pageSize: 10,
        pageNum: 1,
      },
      statusObj: {
        "0": this.$t('cnumber.cnumber6'),
        "1": this.$t('cnumber.cnumber7'),
      },
      total: 0,
    };
  },
  mounted() {
    this.searchList()
  },
  methods: {
    // 新增，编辑
    doEdit(row) {
      this.$modalDialog(() => import('./components/numberItem.vue'), {
        row,
      }).then(
          () => {
            this.searchList()
          },
          () => {
          }
      )
    },
    // 启用/禁用
    doCopy(data) {
      console.log(data)
      const text = data.roleStatus === '0' ? this.$t('cnumber.cnumber6') : this.$t('cnumber.cnumber7')
      const params = {
        ...data,
        roleStatus: data.roleStatus === '0' ? '1' : '0',
      }
      this.$confirm(this.$t('cnumber.cnumber26') + text + this.$t('cnumber.cnumber27'), {
        confirmButtonText: this.$t('confirm'),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t('laund.laund24'),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
          .then(() => {
            this.$http
                .post("admin/subAccountUpdate", params)
                .then((res) => {
                  if (res.data.code == 200) {
                    this.$message({
                      type: "success",
                      message: res.data.message,
                    });
                    this.searchList()
                  } else {
                    this.$message({
                      type: "warning",
                      message: res.data.message,
                    });
                  }
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t('status.status4'),
            });
          });
    },
    // 删除
    drop(data) {
      this.$confirm(this.$t('cnumber.cnumber8'), {
        confirmButtonText: this.$t('confirm'),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t('laund.laund24'),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
          .then(() => {
            this.$http
                .post("admin/subAccountDelete", {
                  ...data,
                  delFlag: "1",
                })
                .then((res) => {
                  if (res.data.code == 200) {
                    this.$message({
                      type: "success",
                      message: res.data.message,
                    });
                    this.searchList();
                  } else {
                    this.$message({
                      type: "warning",
                      message: res.data.message,
                    });
                  }
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t('laund.laund25'),
            });
          });
    },
    searchList() {
      //查询
      this.queryInfo.pageNum = 1;
      this.getDataList();
    },
    async getDataList() {
      //获取信息列表
      const res = await this.$http.get(
          "/admin/subAccountList",
          { params: this.queryInfo }
      );
      console.log(res,'获取信息列表')
      this.dataList = res.data.data
    },
    handleSizeChange(newSize) {
      //分页
      this.queryInfo.pageSize = newSize;
      this.getDataList();
    },
    handleCurrentChange(newPage) {
      //分页
      this.queryInfo.pageNum = newPage;
      this.getDataList();
    },
  }
}
</script>
<style scoped lang="less">
::v-deep .search-container{
  padding: 0;
}
</style>